export const iconSizes = {
  byte: '14px',
  kilo: '16px',
  mega: '24px',
  giga: '32px',
};
